import axios from "axios";
import {
  NEW_REPORT_FILE,
  NEW_REPORT_FILE_SUCCESS,
  NEW_REPORT_FILE_FAILED,
  NEW_REPORT_FILE_RESET,
} from "./actionType";
import axio from "axios";
const baseURL = process.env.REACT_APP_API_BASE_URL;
// const baseURL = "https://rp6pb2z5-7070.inc1.devtunnels.ms/";

export const newReportFile = (data) => async (dispatch) => {
  try {
    dispatch({
      type: NEW_REPORT_FILE,
    });
    dispatch({
      type: NEW_REPORT_FILE_RESET,
    });
    const url = `${baseURL}file-upload/new-reports`;

    const response = await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "69420",
      },
    });
    // check for successful response
    if (response.status >= 200 && response.status < 400) {
      dispatch({ type: NEW_REPORT_FILE_SUCCESS, payload: response.data });
    } else {
      dispatch({
        type: NEW_REPORT_FILE_FAILED,
        payload: response?.statusText || "something went wrong",
      });
    }
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      dispatch({
        type: NEW_REPORT_FILE_FAILED,
        payload: error.response.data.message,
      });
    } else {
      dispatch({
        type: NEW_REPORT_FILE_FAILED,
        payload: error,
      });
    }

    console.error("Error in new report request: ", error);
  }
};
